import { BankCodes } from '@revenuemarket/bank';
import { AccountStatus } from '@revenuemarket/trade';
import qs from 'qs';

import { API } from '~apis/axios/instance';
import { BankAccountTransaction } from '~apis/cash-flow-overview/transactions/getBankAccountTransactions';
import { AccountType } from '~models/bank/enum';
import {
  CursorQueryRequestParams,
  CursorQueryResponse,
  ResponseBaseWithData,
} from '~types/response';

export interface PurgedBankAccountItem {
  bankAccountId: number;
  companyId: string;
  accountNumber: string;
  originalAliasName: string;
  accountHolder: string;
  accountName: string;
  accountNameSub: string;
  bankCode: BankCodes;
  overdraft: boolean;
  displayAccountNumber: string;
  accountType: AccountType;
  currencyCode: string;
  accountStatus: AccountStatus;
  purgedAt: string;
  aliasName: string;
}

export const getPurgedBankAccounts = ({ companyId }: { companyId: string }) => {
  return API.get<ResponseBaseWithData<{ items: PurgedBankAccountItem[] }>>(
    `/api/v3/companies/${companyId}/bank-accounts/purged`,
  );
};

interface PurgedSecurityBankAccountItem {
  id: number;
  companyId: string;
  organizationCode: string;
  accountStatusCode: string;
  account: string;
  accountDisplay: string;
  accountName: string;
  accountNickName: string;
  depositReceived: number;
  depositReceivedF: number;
  depositReceivedD1: number;
  depositReceivedD2: number;
  earningsRate: number;
  loanAmt: number;
  principal: number;
  purchaseAmount: number;
  valuationAmt: number;
  valuationPL: number;
  withdrawalAmt: number;
  createdAt: string;
  updatedAt: string;
}

export const getPurgedSecurityBankAccounts = ({ companyId }: { companyId: string }) => {
  return API.get<ResponseBaseWithData<{ items: PurgedSecurityBankAccountItem[] }>>(
    `/api/v3/companies/${companyId}/security-accounts/purged`,
  );
};

export const getBankTransactionTypes = ({ companyId }: { companyId: string }) => {
  return API.get<ResponseBaseWithData<{ items: string[] }>>(
    `/api/v3/companies/${companyId}/bank/transactions/filters/transaction-types`,
  );
};

export interface BankTransactionQueryParams extends CursorQueryRequestParams {
  type?: 'IN' | 'OUT';
  accounts?: number[];
  transactionTypes?: string[];
  cursorTransactionAt?: string;
}

export const getBankTransactionsByCursor = ({
  companyId,
  queryParams,
}: {
  companyId: string;
  queryParams: BankTransactionQueryParams;
}) => {
  const queryString = qs.stringify(
    {
      ...queryParams,
    },
    { arrayFormat: 'repeat' },
  );

  return API.get<
    ResponseBaseWithData<
      CursorQueryResponse<BankAccountTransaction> & {
        nextCursor: {
          transactionAt: string;
          id: number;
        } | null;
      }
    >
  >(`/api/v3/companies/${companyId}/bank/transactions/by-cursor?${queryString}`);
};
